<button
  class="btn btn-primary"
  (click)="onExportClickEvent()"
  [attr.id]="id"
  type="button"
>
  <fa-icon [icon]="faDownload"></fa-icon>{{ label }}
</button>
